import React from 'react';

import { useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import RadioGroup from '@atlaskit/radio/radio-group';
import TextArea from '@atlaskit/textarea/text-area';

import { OTHER_ID } from '../../../../../../../../common/types/form/form-fields/field-values';
import {
	asFormOptionField,
	toRadioOptions,
} from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';
import { messages } from './messages';

const placeholderStyles = xcss({
	margin: 'space.500',
});

const radioStyles = xcss({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	lineHeight: 'initial',
});

export const PreviewRadioInput = ({
	fieldId,
	fieldInputId,
	fieldLabelId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);
	const formField = useFormField({ fieldId });
	const formOptionField = asFormOptionField(formField);
	const intl = useIntl();

	if (formOptionField === undefined) {
		return <></>;
	}

	return (
		<Box testId="field-input-radio-preview">
			{formOptionField.hasOtherOption || formOptionField.options.length ? (
				<Box xcss={radioStyles}>
					<RadioGroup
						id={fieldInputId}
						key={fieldInputId}
						name={fieldInputId}
						labelId={fieldLabelId}
						options={
							formOptionField.hasOtherOption
								? toRadioOptions([
										...formOptionField.options,
										{ id: OTHER_ID, label: intl.formatMessage(messages.otherOption) },
									])
								: toRadioOptions(formOptionField.options)
						}
						value={
							formOptionField.value?.otherOptionText
								? OTHER_ID
								: (formOptionField.value?.options[0]?.id ?? null)
						}
						isDisabled
						testId={`field-input-radio-preview-${fieldId}`}
					/>
				</Box>
			) : (
				<Box xcss={placeholderStyles} />
			)}
			{formOptionField.value?.otherOptionText && (
				<TextArea
					isDisabled
					value={formOptionField.value.otherOptionText}
					aria-label={intl.formatMessage(messages.otherOptionTextLabel, { label: formField.label })}
				/>
			)}
		</Box>
	);
};
